import { AscProjectMonthAllocation } from '@common/neo.tax';

import { AllocationBar } from './per-month-allocation-summary.styled';
import { getBgColorsForMonthPill } from './per-month-allocation-summary.utils';

interface MonthAllocationBarProps {
  allocation: Pick<AscProjectMonthAllocation, 'ascProjectId' | 'useAllocationPercent' | 'allocationPercent'>[];
  width: 'sm' | 'lg';
}

export const MonthAllocationBarForAscProject = ({
  allocation,
  width,
}: MonthAllocationBarProps): React.ReactElement | null => (
  <AllocationBar
    direction="column"
    spacing={6}
    borderRadius="full"
    width={width}
    style={{ backgroundImage: getBgColorsForMonthPill({ allocation }) }}
  />
);
